import { Box } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import { OverallSummary } from "../OverallSummary/OverallSummary.view";
import { TopFiveFunctionalLocations } from "../TopFiveFunctionalLocations/TopFiveFunctionalLocations.view";
import { TopFiveFailureCodes } from "../../TopFiveFailureCodes/TopFiveFailureCodes.view";
import { useStyles } from "./DowntimeCarousel.styles";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { HMICachedDataContext } from "../../../../contexts/HMICachedDataContext/HMICachedDataContext";
import { useTheme } from "@mui/material";
import { useContext, useMemo } from "react";
import { END_OF_SHIFT_FAILURE_CODE_NAME, MEASURE_METRICS } from "constants/constants";
import { HMIContext } from "contexts/HMIContext/HMIContext";
import { ShiftOptionsEnum } from "components/ShiftDropdown/ShiftDropdown.view";
import { IEventWithHours } from "components/HMIUptimeDowntimeBar/HMIUptimeDowntimeBarInterfaces";

export const DowntimeCarousel = () => {
    const classes = useStyles();
    const themeStyles = useTheme();
    const { store } = useContext(HMICachedDataContext);
    const { shift } = useContext(HMIContext);

    const countryCode =
        store.machineCenter?.production_line.mill.country?.code ??
        store.machineCenter?.production_line.mill.corporate?.country?.code;

    const selectedShiftEvents =
        shift === ShiftOptionsEnum.current
            ? store.lastTwoShiftsEventReports?.currentShiftEventWithHours
            : store.lastTwoShiftsEventReports?.previousShiftEventWithHours;

    const downtimeEvents = useMemo(
        () =>
            selectedShiftEvents &&
            selectedShiftEvents?.reduce((acc: IEventWithHours[], event) => {
                if (
                    event.measure_metric_id === MEASURE_METRICS.DOWNTIME &&
                    event.failure_code?.code !== END_OF_SHIFT_FAILURE_CODE_NAME
                ) {
                    const pendingEditionDetails = store.editionsPending[event.event_report_id];

                    const failureType = pendingEditionDetails?.failureTypeDetails || event.failure_type;
                    const failureCode = pendingEditionDetails?.failureCodeDetails || event.failure_code;
                    const area = pendingEditionDetails?.areaDetails || event.area;
                    const functionalLocation =
                        pendingEditionDetails?.functionalLocationDetails || event.functional_location;

                    const eventDetails = {
                        ...event,
                        ...(failureType && { failure_type: failureType }),
                        ...(failureCode && { failure_code: failureCode }),
                        ...(area && failureType.is_location_specific && { area: area }),
                        ...(functionalLocation &&
                            failureType.is_location_specific && { functional_location: functionalLocation }),
                    };

                    return [...acc, eventDetails];
                }
                return acc;
            }, []),
        [selectedShiftEvents, store.editionsPending],
    );

    return (
        <Box className={classes.carouselContainer}>
            <Carousel
                autoPlay={false}
                indicators={true}
                swipe={false}
                NextIcon={<ArrowForwardIosOutlinedIcon />}
                PrevIcon={<ArrowBackIosNewOutlinedIcon />}
                navButtonsAlwaysVisible={true}
                indicatorIconButtonProps={{
                    style: {
                        marginTop: "10px",
                    },
                }}
                fullHeightHover={false}
                navButtonsProps={{
                    style: {
                        backgroundColor: "transparent",
                        color: themeStyles.palette.border.divider,
                        width: "16px !important",
                        height: "16px !important",
                        margin: `${themeStyles.spacing(10)} 0 0 0`,
                        padding: 0,
                    },
                }}
            >
                <OverallSummary downtimeEvents={downtimeEvents} showTitle={true} countryCode={countryCode} />
                <TopFiveFunctionalLocations
                    downtimeEvents={downtimeEvents}
                    showTitle={true}
                    countryCode={countryCode}
                />
                <TopFiveFailureCodes downtimeEvents={downtimeEvents} showTitle={true} countryCode={countryCode} />
            </Carousel>
        </Box>
    );
};
